import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RobocatMascotModelComponent } from '../robocat-mascot-model/robocat-mascot-model.component';
import type { ChildOption } from '../../models/child-option.model';

@Component({
  selector: 'app-parent-ai-assistant-card',
  standalone: true,
  imports: [TranslatePipe, RobocatMascotModelComponent],
  templateUrl: './parent-ai-assistant-card.component.html',
  styleUrl: './parent-ai-assistant-card.component.scss',
})
export class ParentAiAssistantCardComponent {
  isMobile = input(false);
  isVerificationMode = input(false);
  selectedChild = input<ChildOption | null>(null);
  showTopicsPanel = input(false);
  showTopicsButton = input(true);
  filteredTopicsCount = input(0);

  topicsPanelClick = output<void>();
}
